import {
    CssBaseline,
    StyledEngineProvider,
    ThemeProvider,
} from "@mui/material";
import ReportEditorRv2 from "components/Signals/Reports/Editor/ReportEditorRv2";
import React from "react";
import { Route, Routes } from "react-router-dom";
import theme from "Theme/AppTheme";

function Focus() {
    return (
        <>
            <CssBaseline />
            <Routes>
                <Route
                    path="reporteditor/:orgId/"
                    element={<ReportEditorRv2 />}
                />
                <Route
                    path="reporteditor/:orgId/:reportId"
                    element={<ReportEditorRv2 />}
                />
            </Routes>
        </>
    );
}

export default function FocusContainerRv2(props) {
    return (
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={theme}>
                <Focus />
            </ThemeProvider>
        </StyledEngineProvider>
    );
}
